/**
 * Константы для типов файлов
 */

/**
 * Расширения изображений
 */
export const IMAGE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.svg',
] as const

/**
 * Расширения видео
 */
export const VIDEO_EXTENSIONS = [
  '.mp4',
  '.webm',
  '.mov',
  '.avi',
  '.mkv',
] as const

/**
 * Расширения документов
 */
export const DOCUMENT_EXTENSIONS = {
  PDF: '.pdf',
  WORD: ['.doc', '.docx'],
  EXCEL: ['.xls', '.xlsx'],
  TEXT: '.txt',
  CSV: '.csv',
} as const

/**
 * Расширения архивов
 */
export const ARCHIVE_EXTENSIONS = ['.zip', '.rar'] as const

/** Документы и архивы, доступные для отправки в чат */
export const CHAT_DOCUMENT_EXTENSIONS = [
  DOCUMENT_EXTENSIONS.PDF,
  ...DOCUMENT_EXTENSIONS.WORD,
  ...DOCUMENT_EXTENSIONS.EXCEL,
  DOCUMENT_EXTENSIONS.TEXT,
  DOCUMENT_EXTENSIONS.CSV,
  ...ARCHIVE_EXTENSIONS,
] as const

/** Атрибут accept для input[type=file] в чате */
export const CHAT_FILE_ACCEPT = [
  'image/*',
  'video/*',
  ...CHAT_DOCUMENT_EXTENSIONS,
].join(',')

/**
 * Иконки для типов файлов
 */
export const FILE_ICONS: Record<string, string> = {
  pdf: 'ri-file-pdf-line',
  doc: 'ri-file-word-line',
  docx: 'ri-file-word-line',
  xls: 'ri-file-excel-line',
  xlsx: 'ri-file-excel-line',
  csv: 'ri-file-text-line',
  txt: 'ri-file-text-line',
  zip: 'ri-file-zip-line',
  rar: 'ri-file-zip-line',
} as const

/**
 * Все константы файлов
 */
export const FILE_TYPE_CONSTANTS = {
  IMAGE_EXTENSIONS,
  VIDEO_EXTENSIONS,
  DOCUMENT_EXTENSIONS,
  ARCHIVE_EXTENSIONS,
  FILE_ICONS,
} as const
